import { ComponentType, lazy, ReactNode, Suspense } from 'react';
import { ProgressSpinner } from '@gafe/common-ui';
import { ErrorBoundary } from '@sentry/react';

import { OpsNotificationsProps } from './types';

export type OpsNotificationsCardProps = Omit<OpsNotificationsProps, 'errorMessage' | 'header'> & {
  body?: OpsNotificationsProps['header'];
  errorMessage?: string;
  renderHeader?: ReactNode;
};

export type OpsNotificationsCardComponent = ComponentType<OpsNotificationsCardProps>;

const NotificationsCard = lazy<OpsNotificationsCardComponent>(
  () => import('@gafe-shared/Checkout/OpsNotificationsCard'),
);

export const OpsNotificationsCard = (props: OpsNotificationsCardProps) => {
  return (
    <ErrorBoundary fallback={<> </>}>
      <Suspense fallback={<ProgressSpinner width="md" />}>
        <NotificationsCard {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
